import util from './utils/util';
import store from './store';
import eventBus from './services/eventBus.service';
import * as types from './services/eventBusType';
import { Logger } from './services/logger';
const isPord = process.env.NODE_ENV === 'production';
function stopPropagation(event) {
  if (event) {
    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();
    event.preventDefault();
  }
  return false;
}
if (isPord) {
  const ieLogger = new Logger('ie');
  ieLogger.info(`是否ie:${util.browser.isIE}, ${window.navigator.userAgent}`);
  const resourceLogger = new Logger('resource');
  window.addEventListener(
    'error',
    (event) => {
      if (util.browser.isIE) {
        const target = event.target || event.srcElement;
        if (!target || target.nodeType !== 1) {
          return false;
        }
        if (
          target instanceof HTMLScriptElement ||
          target instanceof HTMLLinkElement ||
          target instanceof HTMLImageElement
        ) {
          const nodeName = target.nodeName;
          let attrLinkName = '';
          let linkVal = '';
          if (target.src) {
            attrLinkName = 'src';
            linkVal = target.src;
          } else if (target.href) {
            attrLinkName = 'href';
            linkVal = target.href;
          }
          const message = `${nodeName}:${attrLinkName}=${linkVal}，加载错误！`;
          resourceLogger.info(message, event);

          return stopPropagation(event);
        }
      }
    },
    true,
  );
  // 浏览器全局阻止reject抛出
  const logger = new Logger('promise');
  window.addEventListener('unhandledrejection', (event) => {
    let {
      reason, // 错误对象
      promise, // 出现异常的promise对象
    } = event;
    if (reason instanceof Error) {
      reason = reason.message + reason.detail;
    } else if (typeof reason === 'string') {
      reason = reason.message;
    } else {
      try {
        reason = JSON.stringify(reason);
      } catch (ex) {
        logger.warn('序列化失败！', ex);
      }
    }
    logger.warn(reason, promise, event);
    return stopPropagation(event);
  });
  const errorLogger = new Logger('globalError');
  const originError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (util.browser.isIE) {
      errorLogger.warn(message, { source, lineno, colno }, error);
      return false;
    }
    return (
      originError &&
      originError.call(this, message, source, lineno, colno, error)
    );
  };
}

function scrollTop(dom, value) {
  if (!dom) {
    return;
  }
  var hasScrollTop = 'scrollTop' in dom;
  hasScrollTop ? (dom.scrollTop = value) : dom.scrollTo(dom.scrollX, value);
}

/**
 * 设置页面高度
 */
function resizeHtmlHei() {
  if (
    document.activeElement &&
    (document.activeElement.nodeName.toUpperCase() === 'INPUT' ||
      document.activeElement.nodeName.toUpperCase() === 'TEXTAREA')
  ) {
    return;
  }
  var height = window.innerHeight;
  var width = window.innerWidth;
  if (document.documentElement) {
    document.documentElement.style.height = `${height}px`;
  }
  document.body.style.height = height + 'px';
  store.commit('frame/setFullFrame', { width: width, height: height });
  var sceneName = store.state.scene.currentScene;
  store.commit('scene/setCurrentScene', '');
  store.commit('scene/setCurrentScene', sceneName);
  scrollTop(document.body, 0);
  scrollTop(document.documentElement, 0);
}

/**
 * 重试设置页面宽高
 */
function retry() {
  let i = 0;
  function start() {
    resizeHtmlHei();
    i++;
    if (i < 3) {
      setTimeout(function () {
        start();
      }, 300);
    }
  }
  start();
}
export function initResizeEvent() {
  eventBus.$on(types.RESIZE, function () {
    retry();
  });
  window.addEventListener('resize', function () {
    retry();
  });
  window.addEventListener('orientationchange', function () {
    retry();
  });
  setTimeout(() => {
    retry();
  }, 0);
  if (
    util.browser.isMobile &&
    util.browser.isIos &&
    util.browser.isSafari &&
    !util.browser.isChrome
  ) {
    // ios 横屏出现导航栏重新获取window.innerWidth
    var scrollIng = false;
    window.addEventListener('scroll', function () {
      scrollIng = true; // 持续滚动
      setTimeout(() => {
        scrollIng = false; // 400毫秒内无滚动操作，认为滚动停止
        setTimeout(() => {
          //
          if (scrollIng) {
            return false;
          }
          retry();
          return true;
        }, 200);
      }, 400);
    });
  }
}
